import React from 'react';

import { KbjCard } from '@eika-kortbetjening/types';

import { replaceXWithBullet } from '../../functions';

import './CardInfoWithImage.scss';

interface CardInfoWithImageProps {
    card: KbjCard;
}

const CardInfoWithImage = ({ card }: CardInfoWithImageProps) => (
    <div className="card-info">
        <div className="card-info-image">
            <img alt={card.name} className="card-info-image__image" src={card.imageUrl} />
        </div>
        <div className="card-info-name-number">
            <span id="card-info-name">{card.name}</span>
            <span id="card-info-number">{replaceXWithBullet(card.number)}</span>
        </div>
    </div>
);

export default CardInfoWithImage;
